import { useEffect, useState, useContext } from "react";
import { RoleContext } from "../../contexts/RoleContext";
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from "@headlessui/react"; 

const RoleSelector = ({ formData, setFormData }) => {
    const { roles, loadRoles } = useContext(RoleContext);
    const token = localStorage.getItem("authToken");
    const [query, setQuery] = useState("");

    // roles are loaded when the component mounts
    useEffect(() => {
    if (token) {
        loadRoles(token);
    }
    }, [token, loadRoles]);

    // // console.log("list roles: ", roles);

    const filteredRoles = roles?.filter(role =>
        role.name.toLowerCase().includes(query.toLowerCase())
    );

    const handleSelection = (selectedRole) => {
        if (!selectedRole) {
            // console.log("Selection cleared");
            setFormData({ ...formData, id: null });
            return;
        }

        // console.log("Selected role: ", selectedRole.name);
        setFormData({ ...formData, id: selectedRole.name });
    };

    return (
        <Combobox value={formData.id} onChange={handleSelection}>
            <div className="relative">
                <ComboboxInput
                    onChange={(event) => setQuery(event.target.value)}
                    displayValue={(roleName) => roleName || ""} // Display selected role name
                    className="w-full p-2 dark:bg-black dark:text-white dark:border-gray-700 border border-gray-300 rounded"
                    placeholder="Select a role"
                />
                <ComboboxOptions className="absolute w-full dark:bg-black bg-white border border-gray-300 rounded mt-1 max-h-60 z-20 overflow-auto">
                    {filteredRoles.length === 0 ? (
                        <div className="p-2 text-gray-500">No roles found</div>
                    ) : (
                        filteredRoles.map((role) => (
                            <ComboboxOption key={role.id} value={role} className="p-2 dark:text-white dark:hover:bg-gray-900 hover:bg-gray-200 cursor-pointer">
                                {role.name}
                            </ComboboxOption>
                        ))
                    )}
                </ComboboxOptions>
            </div>
        </Combobox>
    );
};

export default RoleSelector;
